<template>
  <div class="ghanaHub">
    <BreadsCrums page="ghanaHub" previous="home" />
    <Articles
      :articles="articles"
      :pagination="pagination"
      type="ghanaHub"
      paginationType="ghana-hub"
      v-if="!loading"
    />
    <Loader v-else />
  </div>
</template>

<script>
import Axios from "axios";
import APPURL from "../constant";
export default {
  watch: {
    $route() {
      this.getArticles();
    }
  },
  created() {
    document.title = this.$i18n.t("navBar.ghanaHub");
  },
  mounted() {
    this.getArticles();
  },
  computed: {
    aboutUs() {
      if (this.info[0]) {
        if (this.info[0].aboutFr) {
          return this.info[0].aboutFr;
        } else {
          return this.info[0].aboutUs;
        }
      }
      return "";
    }
  },
  data() {
    return {
      articles: {},
      pagination: {},
      loading: true
    };
  },
  methods: {
    // getNextArticles() {
    //   this.getArticles(this.posts.next_page_url);
    // },
    getArticles(url = APPURL.LINK + "ghana-hub/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.loading = false;
        this.articles = response.data.data.results.posts;
        this.pagination = response.data.data.pagination;
        //console.log(this.articles);
      });
    }
  },
  name: "GhanaHub",
  components: {}
};
</script>

<style>
.aboutservice {
  padding-top: 30px;
  padding-bottom: 0px;
}
.aboutservice .heading-it {
  margin-bottom: 25px;
  text-align: center;
}
.aboutservice .heading-it h1 {
  font-family: "Josefin Sans", sans-serif;
  font-size: 40px;
  color: #000;
  font-weight: 700;
  text-transform: capitalize;
  padding-bottom: 30px;
}
.aboutservice .heading-it img {
  margin-bottom: 15px;
  margin-top: 5px;
}
.aboutservice .heading-it p {
  padding: 0 10px;
  color: #6c6c6c;
}
.afIntro {
  font-size: 20px;
}
</style>
